import { FACTIONS } from "@frontier/content/factions";
import type { FactionId } from "@frontier/content/factions";

export function FactionInsignia({
  factionId,
}: {
  factionId: FactionId | null;
}) {
  return (
    <svg
      className="faction-insignia"
      viewBox="0 0 40 40"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      style={{ color: factionId ? FACTIONS[factionId].color : "#8aa6ae" }}
      aria-hidden="true"
    >
      {factionId === "concord" ? (
        <>
          <path d="M20 3 34 11v17L20 37 6 28V11Z" />
          <path d="m11 22 7 7 12-17M20 3v9" />
        </>
      ) : factionId === "helion" ? (
        <>
          <path d="m20 3 4 10 11-2-6 10 6 9-11-1-4 8-4-8-11 1 6-9-6-10 11 2Z" />
          <circle cx="20" cy="20" r="5" />
        </>
      ) : factionId === "nomads" ? (
        <>
          <path d="m4 27 16-23 16 23-16-7Z" />
          <path d="m10 29 10 7 10-7M20 4v16" />
        </>
      ) : (
        <>
          <circle cx="20" cy="13" r="7" />
          <path d="M7 35v-5a13 13 0 0 1 26 0v5" />
        </>
      )}
    </svg>
  );
}
